import { db } from '../../utils/firebase';

export const getAllFuns = async () => {
  let links = [];

  const querySnapshot = await db.collection("fun").get();

  querySnapshot.forEach(doc => {
    const { content } = doc.data();

    links = content
      .map((link, index) => {
        const visibleText = link.replace(/<[^>]*>/g, " ");

        const yearMatches = visibleText.match(/(?:19|20)\d{2}/g);

        const year = yearMatches
          ? parseInt(yearMatches[yearMatches.length - 1])
          : 0;

        return {
          link,
          index,
          year
        };
      })
      .sort((a, b) => {
        const aText = a.link.replace(/<[^>]*>/g, " ").trim();
        const bText = b.link.replace(/<[^>]*>/g, " ").trim();

        // Puts PhD Timeline first
        if (aText.includes("PhD Timeline")) return -1;
        if (bText.includes("PhD Timeline")) return 1;

        // Newest year first
        if (a.year !== b.year) {
          return b.year - a.year;
        }

        // Preserve existing reverse order within the same year
        return b.index - a.index;
      })
      .map(item => item.link);
  });

  return links;
};